/**
 * Billable crew-hours for a daily report (daily_reports.labor_hours).
 * Two techs for 8 hours is 16. The database accepts 0–240 with two decimals.
 */
export const MAX_LABOR_HOURS = 240;

/** Blank → null; a valid number → that number; anything else → NaN. */
export function parseLaborHours(input: string): number | null {
  const s = input.trim();
  if (s === '') return null;
  if (!/^\d+(\.\d{1,2})?$/.test(s)) return Number.NaN;
  const n = Number(s);
  return n <= MAX_LABOR_HOURS ? n : Number.NaN;
}

/** The validation message for a labor-hours field, or null when it is acceptable. */
export function laborHoursError(input: string, mode: 'draft' | 'submit'): string | null {
  const n = parseLaborHours(input);
  if (Number.isNaN(n)) return `Enter hours as a number from 0 to ${MAX_LABOR_HOURS}, e.g. 16 or 7.5.`;
  if (n == null && mode === 'submit') return 'Enter the total labor hours for today before submitting.';
  return null;
}
